import { useEffect, useState } from "react";
import { deleteSong, getSongCount, getSongsPage } from "../utility/getSongsPage";
import { FiChevronRight, FiChevronLeft } from "react-icons/fi";
import { IconButton } from "@mui/material";
import { BsArrowRepeat } from "react-icons/bs";
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from "../components/button";
import { useNavigate } from "react-router-dom";
import { AiOutlineEdit,AiOutlineDelete } from 'react-icons/ai'
import { Modal } from "antd";
import toast from "react-hot-toast";

function SongList() {

  const navigate = useNavigate()
  const [search, setSearch] = useState("");
  const [songs, setSongs] = useState([]);
  const [selecteddata,setselecteddata] = useState({})
  const [modal,setmodal] = useState(false)
  const [pagination, setPagination] = useState({
    page: 1,
    total: 0,
    totalPage: 1,
    limit: 30,
  });

  async function getData() {
    const count = await getSongCount(search);
    const data = await getSongsPage(pagination.page, pagination.limit,search);

    setSongs(data);

    setPagination((prev) => ({
      ...prev,
      total: count,
      totalPage: Math.ceil(count / prev.limit),
    }));
  }

  useEffect(() => {
    getData();
  }, [pagination.page,search]);

  useEffect(() => {
  const timer = setTimeout(() => {
    setPagination(prev => ({
      ...prev,
      page: 1
    }));
  }, 400); 
  return () => clearTimeout(timer);
}, [search]);


  function resetfunc() {
    setPagination((prev) => ({ ...prev, page: 1 }));
  }

  async function deleteData() {
    try {
      await deleteSong(selecteddata?.titleEN);
      getData()
      toast.success("Song deleted successfully");
    } catch (err) {
      toast.error("Delete failed");
    }
    setmodal(false)
  }

  return (
    <div>

       <Modal
        keepMounted
        open={modal}
        onClose={() => setmodal(false)}
        width={300}
        footer={false}
        closable={false}

      >
        <div>
          <h6 className="font-bold text-[15px] text-center mb-2 w-full">Are you sure?</h6>
          <h6 className='bg-slate-100 text-center text-[12px] p-1.5 font-[400]'>After deleting you cannot retrieve it back before deleting check once whether you have used it in some data</h6>
          <h6 className="text-[12px] mt-2">English Title : <span className="font-[800]">{selecteddata?.titleEN}</span></h6>
          <h6 className="text-[12px] mb-2">Song Number : {selecteddata?.song_num}</h6>
          <div className='flex justify-end mt-3 '>
            <ButtonOutlinedAutoWidth btnName={'Cancel'} onClick={() => setmodal(false)} />
            <div className='ml-2'>
              <ButtonFilledAutoWidth btnName={'Confirm'} onClick={() => deleteData()} />
            </div>
          </div>
        </div>
      </Modal>

      <div className="flex justify-between pb-2 my-2 border-b items-center">
        <h2 className="font-[700] text-[14px]">
          Songs ({pagination.total})
        </h2>

        <div className="flex flex-wrap text-[13px] items-center">
          <h6 className="mr-2 font-[500]">
            Page {pagination.page} of {pagination.totalPage}
          </h6>

          <IconButton onClick={resetfunc}>
            <BsArrowRepeat size={16} />
          </IconButton>

          <IconButton
            onClick={() =>
              pagination.page > 1 &&
              setPagination({ ...pagination, page: pagination.page - 1 })
            }
          >
            <FiChevronLeft
              size={16}
              className={`${pagination.page === 1 ? "opacity-50" : "opacity-100"}`}
            />
          </IconButton>

          <IconButton
            onClick={() =>
              pagination.page < pagination.totalPage &&
              setPagination({ ...pagination, page: pagination.page + 1 })
            }
          >
            <FiChevronRight
              size={16}
              className={`${pagination.page === pagination.totalPage ? "opacity-50" : "opacity-100"}`}
            />
          </IconButton>

          <div className="px-1 mr-1 py-[4px] ">
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search song title..."
            className="border pt-1 px-2 w-[150px] focus:outline-none rounded text-[13px] "
          />
          </div>
            
          <ButtonFilledAutoWidth onClick={()=>navigate('create')} btnName={'Add Song'} />
          
        </div>
      </div>

      <div className="grid md:grid-cols-6 mb-10 gap-2">
        {songs.map((s) => (
          <div key={s.id} className="p-2 relative border rounded">
            <h6 className='flex items-start bg-white absolute top-0 right-0 border-l border-b px-2 py-[4px] font-[500] '>
              <AiOutlineEdit size={12} onClick={() => navigate('edit', { state: s })} className='mr-2' />
               <AiOutlineDelete size={12} onClick={() => {setselecteddata(s);setmodal(true)}} />
            </h6>
            <h6 className="text-[13px] w-[85%]">
              <strong>Title:</strong> {s.titleEN}
            </h6>
            <h6 className="text-[12px]"><strong>Number:</strong> {s.song_num}</h6>
            <h6 className="text-[12px]">
              <strong>Keywords:</strong> {s.keywords?.join(", ")}
            </h6>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SongList;
